import { useId } from 'react';
import { useGetCategoriesTreeByArte } from '../../../../hooks/useCategory';
import SkeletonLoader from '../../../common/SkeletonLoader';
import InfoArteFinalContainer from './InfoArteFinalContainer';
import InfoArteFinalText from './InfoArteFinalText';
import InfoArteFinalTitle from './InfoArteFinalTitle';
import { Tooltip } from 'react-tooltip';
import { IconButton } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import MaterialTooltip from '../../../../ui/tooltip/MaterialTooltip';

const CategoryItem = ({ category, hasNext }) => {
  const id = useId();
  return (
    <>
      <div className="category-item" data-tooltip-id={id}>
        {category.disabled ? (
          <div className="category-item-dot disabled"> &nbsp;</div>
        ) : (
          <div className="category-item-dot"> &nbsp;</div>
        )}
        <div className="category-item-name">{category.name}</div>
      </div>
      {hasNext && <div className="category-item-separator">{'>'}</div>}
      {category.disabled && (
        <Tooltip id={id} place="top" content={`la visibilidad de la categoria "${category.name}" es oculta`} />
      )}
    </>
  );
};

const CategorySection = ({ idArte, issue }) => {
  const { data: categoriesByArteFinal, isLoading } = useGetCategoriesTreeByArte(idArte);

  return (
    <div className="main-info-section-container">
      <InfoArteFinalContainer>
        <InfoArteFinalTitle>
          Categorías
          {issue && (
            <MaterialTooltip variation="warning" title={issue}>
              <IconButton className="alert-message">
                <ReportProblemIcon
                  style={{
                    fontSize: '1.1rem',
                  }}
                  color="warning"
                />
              </IconButton>
            </MaterialTooltip>
          )}
        </InfoArteFinalTitle>
        {isLoading ? (
          <SkeletonLoader count={1} minHeight={'35px'} />
        ) : categoriesByArteFinal.data.length === 0 ? (
          <InfoArteFinalText style={{ fontStyle: 'italic' }}>Sin categorias asociadas</InfoArteFinalText>
        ) : (
          categoriesByArteFinal.data
            .sort((a, b) => a[0].name.localeCompare(b[0].name))
            .map((categoriesRow, index) => (
              <InfoArteFinalText className="categories-row" key={index}>
                {categoriesRow.map((category, index) => (
                  <CategoryItem key={index} category={category} hasNext={index !== categoriesRow.length - 1} />
                ))}
              </InfoArteFinalText>
            ))
        )}
      </InfoArteFinalContainer>
    </div>
  );
};

export default CategorySection;
